// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ReactDnd = require("react-dnd");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");

let HTML5 = {};

let Touch = {};

let Backend = {
  HTML5: HTML5,
  Touch: Touch
};

let Context = {};

let File = {};

let BoxTarget = {};

let DropTarget = {};

function Make(I) {
  let fromItem = item => ({
    type: I.type_(item),
    item: item
  });
  let toItem = js => js.item;
  let JsItem = {
    fromItem: fromItem,
    toItem: toItem
  };
  let getItem = t => Stdlib_Option.map(Primitive_option.fromNullable(t.getItem()), toItem);
  let isDragging = t => t.isDragging();
  let getItemType = t => Primitive_option.fromNullable(t.getItemType());
  let DragSourceMonitor = {
    getItem: getItem,
    isDragging: isDragging,
    getItemType: getItemType
  };
  let getItem$1 = t => Stdlib_Option.map(Primitive_option.fromNullable(t.getItem()), toItem);
  let getClientOffset = t => Primitive_option.fromNullable(t.getClientOffset());
  let DropTargetMonitor = {
    getItem: getItem$1,
    getClientOffset: getClientOffset
  };
  let ConnectableElement = {};
  let DragSource = {};
  let DropTarget = {};
  let useDrag = (begin_, collect, item, param) => {
    let item_type = I.type_(item);
    let item$1 = {
      type: item_type,
      item: item
    };
    return ReactDnd.useDrag({
      collect: collect,
      begin: begin_,
      item: item$1
    });
  };
  let useDrop = (collect, hover, accept, param) => {
    let hover$1 = Stdlib_Option.map(hover, h => ((item, monitor) => h(item.item, monitor)));
    return ReactDnd.useDrop({
      accept: accept,
      collect: collect,
      hover: hover$1
    });
  };
  return {
    JsItem: JsItem,
    DragSourceMonitor: DragSourceMonitor,
    DropTargetMonitor: DropTargetMonitor,
    ConnectableElement: ConnectableElement,
    DragSource: DragSource,
    DropTarget: DropTarget,
    useDrag: useDrag,
    useDrop: useDrop
  };
}

exports.Backend = Backend;
exports.Context = Context;
exports.File = File;
exports.BoxTarget = BoxTarget;
exports.DropTarget = DropTarget;
exports.Make = Make;
/* react-dnd Not a pure module */
